export default __webpack_public_path__ + "static/media/160x90.9cdfeb57.jpg";